import ateliersData from '@/app/data/ateliers.json';
import type { Soin } from './soins';

/** Un atelier collectif utilise exactement le même modèle qu'un soin */
export type Atelier = Soin;

export interface AtelierCategory {
  slug: string;
  name: string;
  description?: string;
  /** Vide : la catégorie s'affiche avec la mention « Programme à venir » */
  ateliers: Atelier[];
}

export interface AtelierWithCategory extends Atelier {
  categorySlug: string;
  categoryName: string;
}

export const atelierCategories: AtelierCategory[] = ateliersData.categories;

export function getAllAteliers(): AtelierWithCategory[] {
  return atelierCategories.flatMap((category) =>
    category.ateliers.map((atelier) => ({
      ...atelier,
      categorySlug: category.slug,
      categoryName: category.name,
    }))
  );
}

export function getAtelierBySlug(slug: string): AtelierWithCategory | undefined {
  return getAllAteliers().find((atelier) => atelier.slug === slug);
}
